"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCurrencyToFloat = exports.delimit = exports.currencyFilter = void 0;
const localeToJs = (s = '') => s.split('.').join('_').split(',').join('.').split('_').join('');
const currencyFilter = (s) => {
    const f = s.match(/[\d.]+(,\d\d|,\d|,|)/);
    return f ? f[0] : '';
};
exports.currencyFilter = currencyFilter;
const delimit = (amount, decimals = 2, isCurrency = false) => {
    if (amount === undefined || amount === null)
        return '';
    if (typeof amount === 'number') {
        return Number(amount).toLocaleString('nl-NL', {
            currency: 'EUR',
            style: isCurrency ? 'currency' : 'decimal',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    }
    else if (typeof amount === 'string') {
        const clean = localeToJs(amount || '0');
        return parseFloat(clean).toLocaleString('nl-NL', {
            currency: 'EUR',
            style: isCurrency ? 'currency' : 'decimal',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });
    }
    return amount;
};
exports.delimit = delimit;
const parseCurrencyToFloat = (amount) => {
    if (typeof amount === 'number') {
        return amount;
    }
    else if (typeof amount === 'string') {
        return parseFloat(localeToJs(!amount ? '0' : amount));
    }
    else {
        console.warn('INCORRECT VARIABLE PASSED TO parseCurrencyToFloat', amount, typeof amount);
        return amount;
    }
};
exports.parseCurrencyToFloat = parseCurrencyToFloat;
